var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { env } from '../environment';
import style from '../css/graphic-text_css';
let GraphicText = class GraphicText extends LitElement {
    constructor() {
        super(...arguments);
        this.type = 'is-stacked-left';
        this.href = undefined;
        this.target = '_self';
        this.icon = '';
        this.icon_color = '';
        this.icon_primary_color = '';
        this.icon_secondary_color = '';
        this.image = '';
    }
    static get styles() {
        if (env.debug) {
            return css ``;
        }
        return [style];
    }
    parseIcon() {
        let family = '';
        let type = '';
        if (this.icon) {
            const spaceIdx = this.icon.indexOf(' ');
            if (spaceIdx !== -1) {
                family = this.icon.slice(0, spaceIdx);
                type = this.icon.slice(spaceIdx + 1);
            }
            else {
                type = this.icon;
            }
        }
        return { family, type };
    }
    isKitIcon() {
        const { family } = this.parseIcon();
        return family === 'fa-kit' || family === 'fa-kit-duotone';
    }
    firstUpdated() {
        const gs1TextContainer = this.shadowRoot.querySelector('figcaption');
        const childArray = Array.from(this.children);
        childArray.forEach((item) => {
            if (!item.hasAttribute('slot')) {
                gs1TextContainer.appendChild(item);
            }
        });
        // Custom kit icons can't render inside graphic-text's shadow DOM because
        // FA kit CSS doesn't cross shadow boundaries. Inject as slotted light-DOM
        // child instead — unless the user already slotted an icon manually.
        if (this.icon &&
            this.isKitIcon() &&
            !this.querySelector('[slot="icon"]')) {
            const { family, type } = this.parseIcon();
            const kitIcon = document.createElement('gs1-fa-icon');
            kitIcon.setAttribute('slot', 'icon');
            kitIcon.setAttribute('family', family);
            kitIcon.setAttribute('type', type);
            if (this.icon_color) {
                kitIcon.style.color = this.icon_color;
            }
            if (family === 'fa-kit-duotone') {
                if (this.icon_primary_color) {
                    kitIcon.setAttribute('dt_first_color', this.icon_primary_color);
                }
                if (this.icon_secondary_color) {
                    kitIcon.setAttribute('dt_second_color', this.icon_secondary_color);
                }
                kitIcon.setAttribute('dt_second_opacity', '1');
            }
            this.appendChild(kitIcon);
        }
    }
    clickRedirect() {
        if (this.href) {
            window.open(this.href, this.target);
        }
    }
    render() {
        const { family: icon_family, type: icon_type } = this.parseIcon();
        const cursor_style = this.href ? 'pointer' : '';
        const isKit = this.isKitIcon();
        return html ` ${env.debug
            ? html `<link rel="stylesheet" href="${env.baseUrl}/css/graphic-text.css" />`
            : html ``}

      <figure
        class="text-with-graphic ${this.type}"
        @click="${this.clickRedirect}"
        style="cursor: ${cursor_style}"
      >
        ${this.image != ''
            ? html `<img src="${this.image}" alt="image" />`
            : html ``}
        ${this.icon != '' && !isKit
            ? html `<gs1-fa-icon
              family="${icon_family}"
              type="${icon_type}"
              style="color: ${this.icon_color}"
              dt_first_color="${this.icon_primary_color}"
              dt_second_color="${this.icon_secondary_color}"
            ></gs1-fa-icon>`
            : html ``}
        <slot name="icon"></slot>
        <figcaption></figcaption>
      </figure>`;
    }
};
__decorate([
    property()
], GraphicText.prototype, "type", void 0);
__decorate([
    property()
], GraphicText.prototype, "href", void 0);
__decorate([
    property()
], GraphicText.prototype, "target", void 0);
__decorate([
    property()
], GraphicText.prototype, "icon", void 0);
__decorate([
    property()
], GraphicText.prototype, "icon_color", void 0);
__decorate([
    property()
], GraphicText.prototype, "icon_primary_color", void 0);
__decorate([
    property()
], GraphicText.prototype, "icon_secondary_color", void 0);
__decorate([
    property()
], GraphicText.prototype, "image", void 0);
GraphicText = __decorate([
    customElement('gs1-graphic-text')
], GraphicText);
export { GraphicText };
//# sourceMappingURL=graphic-text.js.map